<template>
  <div class="bookmarks">
    <app-page-title v-if="getFavors.movies.length !== 0">
      Favoriten -> Filme ({{ getFavors.movies.length }})
    </app-page-title>

    <app-movie-card
      v-if="getFavors.movies.length !== 0"
      :items="getFavors"
    />

    <app-page-title v-if="getFavors.tvShows.length !== 0">
      Favoriten -> Serien ({{ getFavors.tvShows.length }})
    </app-page-title>

    <app-tv-card
      v-if="getFavors.tvShows.length !== 0"
      :items="getFavors"
    />

    <app-page-title v-if="getFavors.people.length !== 0">
      Favoriten -> Personen ({{ getFavors.people.length }})
    </app-page-title>

    <app-person-card
      v-if="getFavors.people.length !== 0"
      :items="getFavors"
    />

    <app-fail-message v-if="getFavors.movies.length === 0 && getFavors.people.length === 0 && getFavors.tvShows.length === 0">
      Do gibt´s no nix zum seng...
    </app-fail-message>

    <app-loader v-if="loading" />
  </div>
</template>

<script>
// TODO: Favoriten ordnen nach "zuletzt hinzugefügt" bzw. eigene Filter einbauen
import { mapState } from 'vuex';
import PageTitle from '../components/PageTitle.vue';
import FailMessage from '../components/FailMessage.vue';
import MovieCard from '../components/MovieCard.vue';
import PersonCard from '../components/PersonCard.vue';
import TvShowCard from '../components/tvShows/TVOverviewCard.vue';

export default {

  components: {
    appPageTitle: PageTitle,
    appFailMessage: FailMessage,
    appMovieCard: MovieCard,
    appPersonCard: PersonCard,
    appTvCard: TvShowCard,

  },
  computed: {
    ...mapState({
      getFavors(state) {
        return state.favors.favors;
      },
    }),
    loading() {
      return this.$store.getters.loading;
    },
    checklogin() {
      return this.$store.getters.login;
    },
  },
  methods: {
    redirect() {
      this.$store.commit('setUserMessage', 'Um zu deine Favoriten zum kemma muasd zu deim Profil geh oder dich registrieren!');
      this.$router.push('/');
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.checklogin) {
        vm.redirect();
      }
    });
  },
};
</script>
